import authService from "@/services/auth";

const state = {
  user: null,
  isAuthenticated: false,
  isAuthLoading: true, // Loading state for auth check on app init
};

const getters = {
  isAuthenticated: (state) => state.isAuthenticated,
  currentUser: (state) => state.user,
  isAuthLoading: (state) => state.isAuthLoading,
};

const mutations = {
  SET_USER(state, user) {
    state.user = user;
  },
  SET_AUTHENTICATED(state, value) {
    state.isAuthenticated = value;
  },
  SET_AUTH_LOADING(state, value) {
    state.isAuthLoading = value;
  },
  LOGOUT(state) {
    state.user = null;
    state.isAuthenticated = false;
  },
};

const actions = {
  /**
   * Initialize auth state on app load
   */
  initializeAuth({ commit }) {
    const user = authService.getCurrentUser();
    const token = authService.getAccessToken();

    if (user && token) {
      commit("SET_USER", user);
      commit("SET_AUTHENTICATED", true);
    }

    commit("SET_AUTH_LOADING", false);
  },

  /**
   * Handle login
   */
  login({ commit }, { user, tokens }) {
    authService.setAuthData(user, tokens);
    commit("SET_USER", user);
    commit("SET_AUTHENTICATED", true);
  },

  /**
   * Handle logout
   */
  logout({ commit }) {
    authService.logout();
    commit("LOGOUT");
  },

  /**
   * Refresh access token
   */
  async refreshToken({ commit }) {
    try {
      await authService.refreshAccessToken();
      return true;
    } catch (error) {
      commit("LOGOUT");
      return false;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
